<template>
    <div class="p-0">
        <form @submit.prevent="validar">
            <h6 class="text-primary linea2">Documentos solicitante</h6>
            <div class="alert alert-secondary fade show" role="alert" :class="error && 'alert-danger'" v-if="mandatorios.length">
                Debes ingresar&nbsp;<span v-for="(i,ii) in mandatorios" :key="i.id">{{i.dt1.toLowerCase()}}<span v-if="ii!==mandatorios.length-1">,&nbsp;</span></span>
            </div>
            <div class="col-md-6 col-12 pt-2">
                <div class="form-group">
                    <label><i class="fa fa-asterisk text-danger"></i>Tipo de documento</label>
                    <combo-box v-model="formulario.tipo" :opciones="lstDocumentos" name="tipo"
                               v-validate="{required:true,obj:true}"></combo-box>
                    <span class="form-text text-danger">{{ errors.first('tipo') }}</span>
                </div>
            </div>
            <div class="col-md-12 col-12">
                <div class="form-group">
                    <label><i class="fa fa-asterisk text-danger"></i>Documento</label>
                    <archivo ref="archivo" v-model="formulario.archivo" name="documento" v-validate="{required:true}" ></archivo>
                    <span class="form-text text-danger">{{ errors.first('documento') }}</span>
                </div>
            </div>
            <div class="col-md-3 col-12">
                <button type="submit" class="btn btn-success btn-elevate btn-pill btn-block">Agregar</button>
            </div>
        </form>
        <div class="table-responsive">
            <table class="table table-sm">
                <thead>
                <tr>
                    <th>Tipo documento</th>
                    <th>Nombre archivo</th>
                    <th>Tipo archivo</th>
                    <th class="text-center">Acción</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(i,ii) in datos.documentos" :key="ii">
                    <th>{{i.tipo}}</th>
                    <td>{{i.nombre}}</td>
                    <td>{{i.ext}}</td>
                    <td class="text-center">
                        <button type="button" class="btn btn-link btn-sm" v-on:click="eliminar(ii,i)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
                <tr v-if="!datos.documentos.length">
                    <td colspan="4" class="text-center text-muted">
                        No hay elementos agregados<br>
                        <span class="text-danger">Agregue elementos con el botón <code>Agregar</code></span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="row pt-4">
            <div class="col-12 col-md-12 p-1">
                <button type="button" class="btn btn-primary btn-elevate btn-pill btn-block" v-on:click="enviar" :class="cargando ? 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light' : ''" :disabled="cargando">Guardar</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {catalogos,documentos} from "../../servicios";
    import archivo from "../boton-file";
    import comboBox from "../comboBox";
    import _ from 'lodash';

    export default {
        name: "documentos",
        data:()=>({
            formulario:{
                tipo:{id:null},
                archivo:null,
            },
            lstDocumentos:[],
            datos:{
                complete:false,
                documentos:[],
            },
            mandatorios:[],
            cargando:false,
            numero:0,
            error:false,
        }),
        props:{
            sync: {
                type: Boolean,
                default: false,
            },
            previos: {
                type: Object
            },
            tipo:{
                type: Object
            }
        },
        components:{
            archivo,
            comboBox
        },
        methods:{
            limpiar:function(){
                this.formulario.tipo={id:null};
                this.formulario.archivo=null;
                this.$refs.archivo.limpiar();
            },
            validar:function(){
                this.$validator.validateAll().then((result) => {
                    if(result){
                        const index = this.lstDocumentos.findIndex(i=>i.id===this.formulario.tipo.id);
                        const obj = {
                            dt1:this.formulario.archivo.base64,
                            ndt2:this.formulario.tipo.id,
                            dto:this.formulario.tipo,
                            ext:this.formulario.archivo.ext,
                            nombre:this.formulario.archivo.nombre,
                            tipo:this.formulario.tipo.dt1,
                        };
                        this.limpiar();
                        this.datos.documentos.push(obj);
                        this.lstDocumentos.splice(index, 1);
                    }else{
                        this.$toast.show(`Completa el formulario ` + this.tipo.titulo);
                    }
                });
            },
            enviar:function(){
                this.error=false;
                let tiene=[];
                this.datos.documentos.map(i=>{
                    this.mandatorios.map(m=>{
                        if(m.id===i.ndt2)
                            tiene.push(i);
                    })
                });
                if(tiene.length===this.mandatorios.length){
                    this.datos.complete=true;
                    this.cargando=true;
                    this.enviarDatos();
                }else{
                    let falta = null;
                    this.error=true;
                    this.mandatorios.map(m=>{
                        let o = this.datos.documentos.find(i=>m.id===i.ndt2);
                        if(!o){
                            falta = m;
                        }
                    });
                    setTimeout(() => {
                        let container = this.$el.querySelector('.alert-danger');
                        container.scrollIntoView();
                    }, 100);
                    this.$toast.show("Debes registrar "+falta.dt1.toLowerCase());
                }
            },
            enviarDatos:_.debounce(function(){
                if(this.datos.documentos.length)
                    documentos.crearDocumentos(this.datos.documentos).then(()=>{
                        this.$emit('input',this.datos);
                        this.cargando=false;
                    });
                else{
                    this.$emit('input',this.datos);
                    this.cargando=false;
                }
            },2000),
            consultaDocumentos:function(){
                catalogos.tipoDocumentoPersona().then(r=>r.data).then(documentos=>{
                    this.lstDocumentos=documentos;
                    documentos.map(i=>{
                       if(i.bdt1)
                           this.mandatorios.push(i)
                    });
                })
            },
            eliminar: function (indice,item) {
                this.lstDocumentos.push(item.dto);
                this.datos.documentos.splice(indice, 1);
            },
        },
        created() {
            this.consultaDocumentos();
        }
    }
</script>

<style scoped>

</style>
